var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.298 15.707a.96.96 0 0 0 .457.258c.176.043.35.043.522 0 .172-.044.324-.129.456-.254L8 9.433l6.272 6.277a.98.98 0 0 0 .712.29.972.972 0 0 0 .723-.294c.192-.2.289-.44.29-.724a.969.969 0 0 0-.287-.712L9.437 7.994l6.272-6.266A.988.988 0 0 0 16 1.011a.947.947 0 0 0-.294-.719 1.005 1.005 0 0 0-.723-.29.961.961 0 0 0-.712.287L7.999 6.564 1.733.288a1.003 1.003 0 0 0-.456-.254A1.108 1.108 0 0 0 .755.029.892.892 0 0 0 .298.29a1.028 1.028 0 0 0-.257.462 1.06 1.06 0 0 0 0 .522.951.951 0 0 0 .254.452L6.56 7.994.295 14.27a1.043 1.043 0 0 0-.263.98.926.926 0 0 0 .266.456z",
    fill: "#7F9292",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.c0aad26e.svg";
export { ForwardRef as ReactComponent };